import api from "../config/api";

// Application oluşturma
export const createApplication = async ({ name, app_site, api_url }) => {
  try {
    const response = await api.post("/applications", {
      name,
      app_site,
      api_url,
    });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Application listesi
export const getApplications = async () => {
  try {
    const response = await api.get("/applications");
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Tek bir application getirme
export const getApplicationById = async (id) => {
  try {
    const response = await api.get(`/applications/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Application durumu güncelleme
export const updateApplicationStatus = async ({ id, status }) => {
  try {
    const response = await api.patch(`/applications/${id}/status`, { status });
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};

// Application silme
export const deleteApplication = async (id) => {
  try {
    const response = await api.delete(`/applications/${id}`);
    console.log("API Response:", response);
    return response;
  } catch (error) {
    console.error("API Error:", error.response || error);
    throw error;
  }
};
